// Digits and nothing else, which is what rejects `8.5`, `1e3`, `+8433` and a leading `-` before
// `Number` ever coerces them into something plausible.
const WHOLE_NUMBER = /^\d+$/;

// The panel's whole definition of «an id with a valid format», in one place: the batch parse reads
// it token by token, and the lookup reads it over the one thing that was typed.
//
// It answers what the token LOOKS like, never whether it exists — no read can tell us that, because
// `GET /{id}` never 404s.
//
// Trimming is the CALLER's job. The batch parse splits on whitespace and never sees a padded token;
// the lookup card trims what was pasted before it asks. Keeping the rule strict is what keeps it one
// testable definition instead of two lenient ones.
export function parseLocationId(token: string): number | null {
  if (!WHOLE_NUMBER.test(token)) return null;
  // `>= 1` is the half the regex cannot do: it is what rejects `0` and `00`.
  const id = Number(token);
  return id >= 1 ? id : null;
}
